import OfficerCreate from './OfficerCreate.container';

export default OfficerCreate;
